module.exports = __webpack_public_path__ + "static/media/caucion.5880f1e7.svg";